import numeral from "numeral";
import moment from "moment";
import _ from "lodash";

const NULL_FIELD = "--";

export function formatDisplayValue(data) {
  if (_.get(data, "displayValue")) {
    return _.get(data, "displayValue");
  }

  return "--";
}
export function formatCurrency(data) {
  const val = _.get(data, "decimalValue");
  if (val === undefined) {
    return "--";
  }
  const roundedVal = val.toFixed(0);
  if (Math.abs(roundedVal) < 100000) {
    return `${numeral(roundedVal).format("$0,0a")}`;
  }
  // if less than 1 million, format is without decimals
  if (Math.abs(roundedVal) < 1000000) {
    return `${numeral(roundedVal).format("($0,0a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(roundedVal) >= 1000000) {
    return `${numeral(roundedVal).format("($0,0.00a)").toUpperCase()}`;
  }
}

export const formatCurrencyNoDecimal = value => {
  let newValue = value;
  if (value >= 1000) {
    const suffixes = ["", "k", "m", "b", "t"];
    const suffixNum = Math.floor((`${value}`).length / 3);
    let shortValue = "";
    for (const precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
      const dotLessShortValue = (`${shortValue}`).replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 != 0) {
      shortValue = shortValue.toFixed(1);
    }
    newValue = shortValue + suffixes[suffixNum];
  }

  return newValue;
};

export function formatCurrencyTwoDecimal(data) {
  const val = _.get(data, "decimalValue");
  if (val === undefined) {
    return "--";
  }
  if (Math.abs(val) < 100000) {
    return `${numeral(val).format("($0,0.00)")}`;
  }
  // if less than 1 million, format is without decimals
  if (Math.abs(val) < 1000000) {
    return `${numeral(val).format("($0,0.00a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(val) >= 1000000) {
    return `${numeral(val).format("($0,0.00a)").toUpperCase()}`;
  }
}
export function formatRate(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0.00%");
  }

  return "--";
}
export function formatDscr(data) {
  const dscrValue = _.get(data, "decimalValue");
  if (dscrValue !== undefined) {
    return `${numeral(data.decimalValue).format("0.00")}x`;
  }

  return "--";
}
export function formatRateThreeDecimal(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0.000%");
  }

  return "--";
}
export function formatDecimalAsInteger(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0,0");
  }

  return "--";
}
export function formatInteger(data) {
  if (_.get(data, "integerValue") !== undefined) {
    return numeral(data.integerValue).format("0,0");
  }

  return "--";
}

export function formatMonths(data) {
  if (_.get(data, "integerValue") !== undefined) {
    return data.integerValue;
  }

  return "--";
}

export function formatDaysToYears(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return moment.duration(data.decimalValue, "days").as("years");
  }

  return "--";
}

export function formatDate(data) {
  if (_.get(data, "dateValue") !== undefined) {
    return moment(data.dateValue).format("MM/DD/YYYY");
  }

  return "--";
}
export function formatNumberOneDecimal(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0,0.0");
  }

  return "--";
}
export function formatNumberTwoDecimal(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0,0.00");
  }

  return "--";
}
export function formatNumberTwoDecimalWithRounding(data) {
  const val = _.get(data, "decimalValue");
  if (val === undefined) {
    return "--";
  }
  /*
   * if (Math.abs(val) < 100000) {
   *   return `${numeral(val).format('(0,0.00)')}`;
   * }
   * if less than 1 million, format is without decimals
   */
  if (Math.abs(val) < 1000000) {
    return `${numeral(val).format("(0,0a)")}`;
  }
  // if 1 million or above, format is always with two decimals
  if (Math.abs(val) >= 1000000) {
    return `${numeral(val).format("(0,0.00a)").toUpperCase()}`;
  }
}
export function formatDecimalNoDecimal(data) {
  if (_.get(data, "decimalValue") !== undefined) {
    return numeral(data.decimalValue).format("0,0");
  }

  return "--";
}
export function notImplemented(data) {
  return "--";
}

// metric specific formatters
export function formatPrepaymentPenalty(data) {
  if (_.get(data, "displayValue")) {
    return _.get(data, "displayValue");
  }

  return formatCurrency(data);
}

export function formatExtensionsQualification(data) {
  if (_.has(data, "integerValue")) {
    return data.integerValue ? "QUALIFIED" : "NOT QUALIFIED";
  }

  return NULL_FIELD;
}
